import { ChangeEvent, useCallback, useState } from 'react';
import _ from 'lodash';
import { Box } from '@mui/material';
import { TextInput } from '@tassomutuo-backoffice/ui';

interface IProps {
  onSubmit: (text: string) => void;
}

const FilterGroupInput = ({ onSubmit }: IProps) => {
  const [inputText, setInputText] = useState('');

  const debouncedSubmit = useCallback(
    _.debounce((text: string) => {
      onSubmit(text);
    }, 800),
    [onSubmit]
  );

  const onChangeHandler = (e: ChangeEvent<HTMLInputElement>) => {
    const newText = e.target.value;
    setInputText(newText);
    debouncedSubmit(newText);
  };

  return (
    <Box maxWidth="250px">
      <TextInput
        type="text"
        label="Cerca per nome del gruppo"
        value={inputText}
        onChange={onChangeHandler}
      />
    </Box>
  );
};

export default FilterGroupInput;
